import React from 'react';

import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { Link, useHistory } from 'react-router-dom';

import Breadcrumbs from 'components/Breadcrumbs';
import { useFeatures, FeatureFlags } from 'contexts/features';
import {
  CHARGING_STATIONS_POLICIES_AND_GROUPS_ROUTE,
  CHARGING_STATIONS_POLICIES_AND_GROUPS_CHARGING_GROUPS_ROUTE,
  CHARGING_STATIONS_POLICIES_AND_GROUPS_CHARGING_POLICIES_ROUTE,
  CHARGING_STATIONS_POLICIES_AND_GROUPS_CUSTOMER_GROUPS_ROUTE,
  CHARGING_STATIONS_POLICIES_AND_GROUPS_EDIT_CHARGING_POLICY_ROUTE,
  CHARGING_STATIONS_POLICIES_AND_GROUPS_NEW_CHARGING_POLICY_ROUTE,
  CHARGING_STATIONS_ROUTE,
} from '../../router/routes';

export function CpoBreadcrumbs() {
  const history = useHistory();
  const { t } = useTranslation();
  const { hasFeature } = useFeatures();

  const breadcrumbs = [];
  switch (history.location.pathname) {
    case CHARGING_STATIONS_POLICIES_AND_GROUPS_ROUTE:
    case CHARGING_STATIONS_POLICIES_AND_GROUPS_CHARGING_POLICIES_ROUTE:
    case CHARGING_STATIONS_POLICIES_AND_GROUPS_CUSTOMER_GROUPS_ROUTE:
    case CHARGING_STATIONS_POLICIES_AND_GROUPS_CHARGING_GROUPS_ROUTE:
    case CHARGING_STATIONS_POLICIES_AND_GROUPS_NEW_CHARGING_POLICY_ROUTE:
    case CHARGING_STATIONS_POLICIES_AND_GROUPS_EDIT_CHARGING_POLICY_ROUTE:
      if (hasFeature(FeatureFlags.PoliciesAndGroups)) {
        breadcrumbs.push(
          ...[
            {
              path: CHARGING_STATIONS_ROUTE,
              title: t('chargingStations.title', 'Charging Stations'),
            },
            {
              path: CHARGING_STATIONS_POLICIES_AND_GROUPS_ROUTE,
              title: t('policiesAndGroups.title', 'Policies & Groups'),
            },
          ]
        );
      }
      break;
  }

  if (isEmpty(breadcrumbs)) {
    return null;
  }

  return (
    <Breadcrumbs
      path={breadcrumbs.slice(0, -1).map((breadcrumb) => (
        <Link key={breadcrumb.path} to={breadcrumb.path}>
          {breadcrumb.title}
        </Link>
      ))}
      active={breadcrumbs[breadcrumbs.length - 1].title}
    />
  );
}
